import React, { createContext, useContext, useEffect, useState } from 'react';
import { io } from 'socket.io-client';
import { useAuth } from './AuthContext';

const SocketContext = createContext();

export function useSocket() {
  return useContext(SocketContext);
}

export function SocketProvider({ children }) {
  const [socket, setSocket] = useState(null);
  const [connectionError, setConnectionError] = useState(null);
  const { user } = useAuth();
  
  useEffect(() => {
    // Initialize socket connection
    const newSocket = io(
      process.env.NODE_ENV === 'production' 
        ? window.location.origin 
        : 'http://localhost:5000',
      {
        withCredentials: true,
        transports: ['websocket', 'polling'],
        reconnectionAttempts: 5,
        reconnectionDelay: 1000
      }
    );
    
    newSocket.on('connect', () => {
      console.log('Socket connected successfully');
      setConnectionError(null);
    });
    
    newSocket.on('connect_error', (error) => {
      console.error('Socket connection error:', error);
      setConnectionError('Failed to connect to server. Please try again later.');
    });
    
    setSocket(newSocket);
    
    // Clean up on unmount
    return () => {
      newSocket.disconnect();
    };
  }, []);
  
  // Functions for socket interactions
  const joinWorld = (worldId) => {
    if (!socket) {
      console.error('Socket not initialized');
      return;
    }
    
    if (!user) {
      console.error('User not authenticated');
      return;
    }
    
    socket.emit('join-world', {
      worldId,
      username: user.username,
      avatar: user.avatar || 'default'
    });
  };
  
  const updateUserPosition = (position, rotation, controllers) => {
    if (socket) {
      socket.emit('user-update', {
        position,
        rotation,
        controllers
      });
    }
  };
  
  const updateObject = (objectData) => {
    if (socket) {
      socket.emit('object-update', objectData);
    }
  };
  
  const sendChatMessage = (message) => {
    if (socket) {
      socket.emit('chat-message', message);
    }
  };
  
  const value = {
    socket,
    connectionError,
    joinWorld,
    updateUserPosition,
    updateObject,
    sendChatMessage
  };
  
  return (
    <SocketContext.Provider value={value}>
      {children}
    </SocketContext.Provider>
  );
} 